import { Eye, PencilSimple } from "@magnetic/icons";
import { Text } from "@magnetic/text";

import { Button } from "src/components/buttons";
import { HFlex } from "src/components/hFlex";
import { withShowToggle } from "src/components/hoc/withShowToggle";

import { ButtonProps } from "./types";

export const ViewRunning = withShowToggle(({ handleAction }: ButtonProps) => {
  return (
    <HFlex align="center" justify="center" gap="sm">
      <Text className="candidate-mode-text">Edit mode</Text>
      <HFlex
        align="center"
        justify="center"
        gap="xs"
        className="action-buttons"
      >
        <Button
          name="disabled-edit-mode-button"
          kind="secondary"
          disabled={true}
        >
          <PencilSimple />
        </Button>
        <Button
          title="Switch to running mode"
          name="running-mode-button"
          kind="primary"
          onClick={handleAction}
        >
          <Eye />
        </Button>
      </HFlex>
    </HFlex>
  );
});
